import { render, staticRenderFns } from "./EvaluationPdfReader.vue?vue&type=template&id=cd45055c&"
import script from "./EvaluationPdfReader.vue?vue&type=script&lang=js&"
export * from "./EvaluationPdfReader.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationPdfReader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports